



























import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class BaseState extends Vue {
  get itemListUrl(): string {
    /**
     * 「プランに紐付いている商品」というフィルタリングが ledian v1 時点ではEngienサポートされていないので、
     * 一旦は単に商品一覧ページへ飛ばす.
     *
     * TODO: リソースからブランドを識別可能になったら、ブランドに応じたURLを構築する.
     * @see https://my-color.esa.io/posts/769#複数ブランドが並立する環境へ横展開する場合について
     * @see BrandRouteResolver
     */
    return '/itemlist'
  }
}
